import { createRouter, createWebHistory } from "vue-router"
import Layout from "../views/Layout_Extracao"
import Home from "../views/Home/Home.vue"
import Items from "../views/ItemsChecklist"
import Produtos from "../views/Produtos"
import Moldes from "../views/Molde"
import Materia from "../views/MateriaPrima"
import Maquinas from "../views/Maquinas"
import exportRRIM from "../components/Export/ExportRRIM_Document.vue"
import { api } from "../http"
import { store } from "../store/store"

const routes = [
  { path: "/", component: Home },
  { path: "/home", component: Home },
  { path: "/items-checklist", component: Items },
  { path: "/layout-extracao", component: Layout },
  { path: "/produtos", component: Produtos },
  { path: "/moldes", component: Moldes },
  { path: "/materia-prima", component: Materia },
  { path: "/maquinas", component: Maquinas },
  { path: "/export", component: exportRRIM },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async () => {
  const user = store.state.user;

  if (Object.keys(user).length > 0) {
    return true;
  }

  try {
    const response = await api.post(
      `${process.env.API_SYSTEM_USER}/session/verify`
    );
    store.commit("SetUsers", response.data);

    return true;
  } catch (e) {
    window.location.replace(process.env.VITE_SYSTEM_USER_FRONT);
    return false;
  }
})

export { router }
